import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { FC } from 'react';
import { Verified } from '../item/actions/verified';

export const VerifiedFeature: FC<CatalogItemViewModel> = ({ clientProfile }) => {
  if (!clientProfile) {
    return null;
  }
  return <Verified isVerified={clientProfile?.isDocumentsChecked} />;
};
